import ApprovalPage from './ApprovalPage';

const RejectPage = () => {
  return <ApprovalPage />;
};

export default RejectPage;
